// extracted by mini-css-extract-plugin
export default {"image":"_2SEuwkJlgzbrBGoeO2Jwm2","hiddenImage":"_1VtAbs26ReSoS2gTds5sdJ","annotating":"_22Mg36IYpwy5pvsfzr1LU6"};